/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ArticlePageData } from './ArticlePageData'
import {
  ArticlePageDataFromJSON,
  ArticlePageDataFromJSONTyped,
  ArticlePageDataToJSON,
} from './ArticlePageData'

/**
 *
 * @export
 * @interface GetArticle200Response
 */
export interface GetArticle200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetArticle200Response
   */
  status: boolean
  /**
   *
   * @type {ArticlePageData}
   * @memberof GetArticle200Response
   */
  data: ArticlePageData
}

/**
 * Check if a given object implements the GetArticle200Response interface.
 */
export function instanceOfGetArticle200Response(
  value: object
): value is GetArticle200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetArticle200ResponseFromJSON(
  json: any
): GetArticle200Response {
  return GetArticle200ResponseFromJSONTyped(json, false)
}

export function GetArticle200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetArticle200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: ArticlePageDataFromJSON(json['data']),
  }
}

export function GetArticle200ResponseToJSON(
  value?: GetArticle200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: ArticlePageDataToJSON(value['data']),
  }
}
